import React from 'react'
import { CloseCircle } from '../../../MakersV2/Theme/Icons';
import { PopupBody, PopupWrapper } from './CommonPopup';
import { Button, Flexbox } from '../../Theme/GlobalStyles';
import { Text } from '../../Theme/Typography';

const LogoutPopup = ({showActive, message, onCancel, onAllow, userId, isPopupFetching}) => {
  return (
      <PopupWrapper className={`${showActive ? 'active' : ''}`}>
    <PopupBody maxWidth={450}>
        <Flexbox flexEnd>
                         <CloseCircle className={'pointer'} onClick={() => onCancel(false)}/>
        </Flexbox>
        <Text font16 inter medium white textCenter className='mb20 mt20'>{message}</Text>
        <Flexbox alignCenter gap={12} justiCenter >
                    <Button buttonMd greyFilled name={'No, Cancel'} onClick={() => onCancel(false)}/>
             <Button
             redFilled
  name="Yes, I’m Sure"
  buttonMd
  isWaiting={isPopupFetching}
  onClick={() => onAllow(userId || true)}
/>
        </Flexbox>
    </PopupBody>
    </PopupWrapper>
  )
}

export default LogoutPopup